import { render, staticRenderFns } from "./productsDetailTwo.vue?vue&type=template&id=6cd54b1c&scoped=true&"
import script from "./productsDetailTwo.vue?vue&type=script&lang=js&"
export * from "./productsDetailTwo.vue?vue&type=script&lang=js&"
import style0 from "./productsDetailTwo.vue?vue&type=style&index=0&id=6cd54b1c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd54b1c",
  null
  
)

export default component.exports